import { Utils } from "./utils";
import { ZEvents } from "./events";

export class UI{

    static overlayWatcher(){
        ZEvents.addCustomEvent("ui", "overlayShown", `overlay.shown`);
        document.querySelectorAll(".modal").forEach( (element) => {
            element.addEventListener('shown.bs.modal', () => {
                ZEvents.triggerEvent("ui","overlayShown");
            });
        });
    }

    static hashScrollWatcher(){

        document.querySelectorAll("a[href^='#']").forEach( element => {
            let elementID = element.getAttribute("href");
            if( elementID == "#" ){ return; }
            if( document.querySelector(elementID) ){
                let targetElement = document.querySelector(elementID);
                element.addEventListener("click", (e) => {
                    e.preventDefault();
                    let verticalOffset = 0;
                    if( document.querySelector(elementID).getAttribute("data-scroll-offset") ){
                        verticalOffset = parseInt(document.querySelector(elementID).getAttribute("data-scroll-offset"));
                    }

                    //Checks if header is position fixed and interfers with element's visibility
                    if( document.querySelector("header") ){
                        var headerPosition = window.getComputedStyle(document.querySelector('header')).getPropertyValue('position');
                        if( headerPosition == "fixed" ){
                            verticalOffset += document.querySelector("header").clientHeight;
                        }
                    }

                    window.scrollTo(
                        {
                            top : targetElement.offsetTop - verticalOffset,
                            behavior : "smooth"
                        }
                    );
                } );

            }
        });
    }

    static setupActionEvents(){
        ZEvents.addCustomEvent("actions", "actionLoading", "actionLoading");
        ZEvents.addCustomEvent("actions", "actionSuccess", "actionSuccess");
        ZEvents.addCustomEvent("actions", "actionError", "actionError");
    }

    static fakeHrefs(){
        document.querySelectorAll(`[data-${Utils.getVarNS()}-href]`).forEach( element => {
            element.addEventListener("click", (e) => {
                var link = element.getAttribute(`data-${Utils.getVarNS()}-href`);
                window.location.href = link;
            });
        });
    }

    static clicksTriggerWatcher(){
        document.addEventListener("click", (e) => {
            var target = e.target;
            if( target.getAttribute("data-click-target") !== undefined ){
                var clickTarget = target.getAttribute("data-click-target");
                if( document.querySelector(clickTarget) !== null && document.querySelector(clickTarget) !== undefined ){
                    document.querySelector(clickTarget).click();
                }
            }
        });
    }

}
